import {
  getAuth,
  signOut,
  getIdToken,
  signInWithPopup,
  signInWithRedirect,
  OAuthProvider,
  signInWithEmailAndPassword,
  getMultiFactorResolver,
  PhoneAuthProvider,
  PhoneMultiFactorGenerator,
  RecaptchaVerifier,
  setPersistence,
  browserSessionPersistence,
  multiFactor
} from "firebase/auth";
import { TENANT_ID } from '../configuration/general-config'
import { EMAIL_SIGN_IN_ERROR_MESSAGES, EMAIL_SIGN_IN_STATUS, SIGN_IN_ERROR_MESSAGES, SIGN_IN_STATUS } from "./constants";
import { app } from "../configuration/gcp-identity-platform-config";
import OTPModal from '../components/otpPopup/otpModal';
import { createRoot } from 'react-dom/client';
import { showAlertPopup } from "../redux/actions/AlertErrorMessage/alertErrorMessage.action";
import { varifyEmailcustomTokenOtp } from "../api/userManagement/mfa.service";
import { extractJson } from "../utils/arrayUtils";
import ReactivationResetPopup from "../components/reactivationPasswordResetPopup/reactivationResetPopup";
import { resetPassword } from "../api/userManagement/forgotPassword.service";
import { useState } from "react";

export const vfLogin = () => {
  return new Promise((resolve, reject) => {
    const provider = new OAuthProvider('microsoft.com');
    provider.setCustomParameters({
      tenant: TENANT_ID,
      prompt: 'select_account'
    });

    const auth = getAuth(app);
    const isLocalhost = true;  // window.location.hostname === 'localhost';
    //isLocalhost varibale used to check login using popup or redirect method. as of now redirect is not working on the prod so default using popup login

    if (isLocalhost) {
      signInWithPopup(auth, provider)
        .then((result) => {
          resolve(true);
        })
        .catch((error) => {
          reject(error);
          // Handle error.
        });
    } else {
      signInWithRedirect(auth, provider)
        .then((result) => {
          resolve(true);
        })
        .catch((error) => {
          reject(error);
          // Handle error.
        });
    }
  });
}

export function logOut() {
  return new Promise((resolve, reject) => {
    const auth = getAuth(app);
    signOut(auth)
      .then(() => {
        resolve();
      })
      .catch((error) => {
        console.log("error ",error)
        reject();
      });
  });
}

export async function getAccessToken() {
  const auth = getAuth(app);
  const user = auth.currentUser;
  if (user) {
    const token = await getIdToken(user);
    return token;
  } else {
    return "";
  }
}
export async function getAccessTokenForceRefresh() {
  const auth = getAuth(app);
  const user = auth.currentUser;
  if (user) {
    const token = await getIdToken(user, true);
    return token;
  } else {
    return "";
  }
}

// export function loginWithEmailIdPassword(_email, _password) {
//   return new Promise((resolve, reject) => { 
//     const auth = getAuth(app);
//     signInWithEmailAndPassword(auth, _email, _password)
//     .then((userCredential) => {
//       // Signed in            
//         const { emailVerified } = userCredential.user;
//         const resolveStatus = emailVerified ? SIGN_IN_STATUS.SUCCESS : SIGN_IN_STATUS.UNVERIFIED_EMAIL;
//         resolve(resolveStatus);
//     }) .catch((error) => {  
//       reject(SIGN_IN_STATUS.INVALID_CREDENTIALS);
//     })
//   })

// }

export const loginWithEmailIdPassword = (_email, _password) => { //CUP-666
  return new Promise((resolve, reject) => {
    
    const auth = getAuth(app);
    try {
      if (!window.recaptchaVerifier) {
        window.recaptchaVerifier = new RecaptchaVerifier(
          auth,
          "captcha-container",
          {
            "size": "invisible",
            "callback": function (response) {

            },
            "expired-callback": function () {

            },
          }
        );

        // window.recaptchaVerifier.render()
        //   .then(function (widgetId) {
        //     window.recaptchaWidgetId = widgetId;
        //   });
      }
    } catch (error) {
      console.error("Recaptcha error", error)
      reject(SIGN_IN_STATUS.RECAPTCHA_ISSUE)
      //window.recaptchaVerifier?.clear();
    }

    // Signin with Email and Password
    signInWithEmailAndPassword(auth, _email, _password)
      .then((userCredential) => {
        // Signed in       
        const { emailVerified } = userCredential.user;
        const resolveStatus = emailVerified ? SIGN_IN_STATUS.MFA_DISABLED : SIGN_IN_STATUS.UNVERIFIED_EMAIL
        resolve(resolveStatus);
      })
      .catch((error) => {
        // console.error("signInWithEmailAndPassword", error)
        const errorResponse = extractJson(error?.message);
        // console.log("errorResponse", errorResponse?.error);
        if (
          errorResponse?.error?.status === "FAILED_PRECONDITION" &&
          errorResponse?.error?.details?.code === "RESET_PASSWORD_REQUIRED"
        ) {
          passwordResetRequire(_email)
            .then((response) => {
              // console.log("response: ", response);
            })
            .catch((error) => {
              reject(error);
            });
        } else if (errorResponse?.error?.status === "FAILED_PRECONDITION") {
          handleEmailMultiFactorAuth(
            errorResponse.error.message,
            _email,
            _password,
            error.code
          )
            .then(() => {
              resolve(SIGN_IN_STATUS.SUCCESS);
            })
            .catch((error) => {
              reject(error); //Error == CLOSE_POPUP
            }); 
          }else {
          switch (error.code) {
            case "auth/multi-factor-auth-required":
              handleMultiFactorAuth(auth, error)
                .then(() => {
                  resolve(SIGN_IN_STATUS.SUCCESS);
                })
                .catch((error) => {
                  reject(error);
                });
              break;
            case "auth/too-many-requests":
              reject(SIGN_IN_STATUS.TOO_MANY_REQUEST);
              break;
            case "auth/invalid-credential":
              reject(SIGN_IN_STATUS.INVALID_CREDENTIALS);
              break;
            case "auth/user-disabled":
              reject(SIGN_IN_STATUS.CUSTOMER_USER_DISABLED);
              break;
              case "auth/password-does-not-meet-requirements":
                passwordResetRequire(_email)
                .then((response) => {
                })
                .catch((error) => {
                  reject(error);  //Error == CLOSE_POPUP
                });
              break; 
            default:
              reject(SIGN_IN_STATUS.RECAPTCHA_ISSUE);
              break;
          }
          }
      }
      );

  });

}

const handleMultiFactorAuth = (auth, error) => {
  return new Promise((resolve, reject) => {
    const resolver = getMultiFactorResolver(auth, error);
    const phoneInfoOptions = {
      multiFactorHint: resolver.hints[0],
      session: resolver.session
    };
    const phoneAuthProvider = new PhoneAuthProvider(auth);
    let verificationId;

    phoneAuthProvider.verifyPhoneNumber(phoneInfoOptions, window.recaptchaVerifier)
      .then((id) => {
        verificationId = id;
       // const promptMessage = `Please enter the verification code sent on ${resolver.hints[0].phoneNumber} (${resolver.hints[0].displayName}), via SMS.`;
        const promptMessage = `Please enter the verification code sent via SMS to ${resolver.hints[0].phoneNumber} (${resolver.hints[0].displayName}).`;

        const container = document.createElement('div');
        document.body.appendChild(container);
        const root = createRoot(container);

        const handleOTPSubmit = (verificationCode) => {
          const cred = PhoneAuthProvider.credential(verificationId, verificationCode);
          const multiFactorAssertion = PhoneMultiFactorGenerator.assertion(cred);
          resolver.resolveSignIn(multiFactorAssertion)
            .then(() => {
              resolve();
              root.unmount(); 
              document.body.removeChild(container);
            })
            .catch((error) => {
              console.error("handleMultiFactorAuth", error);
              switch (error.code) {
                case "auth/invalid-verification-code":
                  reject(SIGN_IN_STATUS.INVALID_VERIFICATION_CODE);
                  break;
                case "auth/missing-code":
                  reject(SIGN_IN_STATUS.MISSING_VERIFICATION_CODE);
                  break;
                default:
                  reject(SIGN_IN_STATUS.RECAPTCHA_ISSUE);
                  break;
              }
                //window.recaptchaVerifier?.clear();
                root.unmount(); 
                document.body.removeChild(container);
            });
        };

        const handleOTPCancel = () => {
          reject(SIGN_IN_STATUS.CLOSE_POPUP);
          root.unmount();
          document.body.removeChild(container);
        };

        root.render(
          <OTPModal
            promptMessage={promptMessage}
            onSubmit={handleOTPSubmit}
            onCancel={handleOTPCancel}
          />
        );
      })
      .catch((error) => {
        console.error("handleMultiFactorAuth", error);
        reject(SIGN_IN_STATUS.RECAPTCHA_ISSUE);
      });
  });
};

const handleEmailMultiFactorAuth = (token,_email, _password) => {
  return new Promise((resolve, reject) => {
    const promptMessage = <div>Please enter the one-time verification code sent to your registered email address. This code is valid for the next <b>5 minutes</b> and can be used <b>only once</b>.</div>;
    const container = document.createElement('div');
    document.body.appendChild(container);
    const root = createRoot(container);
    const handleOTPSubmit = (verificationCode) => {
      const obj = { otp: verificationCode };
      varifyEmailcustomTokenOtp(token, obj)
        .then((response) => {
          const auth = getAuth();
          signInWithEmailAndPassword(auth, _email, _password)
            .then((res) => {
              resolve();
            })
            .catch((error) => {
              console.log("error", error);
              reject(error.code);
            });
        })
        .catch((error) => {
          reject(error.code);
        });
      root.unmount();
      document.body.removeChild(container);
    };

    const handleOTPCancel = () => {
      reject(SIGN_IN_STATUS.CLOSE_POPUP);
      root.unmount();
      document.body.removeChild(container);
    };

    root.render(
      <OTPModal
        promptMessage={promptMessage}
        onSubmit={handleOTPSubmit}
        onCancel={handleOTPCancel}
      />
    );
  });
};

const passwordResetRequire = (emailId) => {
  let showMessage = null;
  return new Promise((resolve, reject) => {
    const promptMessage = 
    <div>
    <div>For security reasons, please reset your password before logging in. This may be due to recent account reactivation or non-compliance with password policy.</div>
        <div style={{marginBottom:"10px"}}><b>Password Requirements</b></div>
        <div style={{marginBottom:"10px" ,marginLeft:"20px"}}>
        <li>Minimum <b>8 characters</b></li>
        <li>At least <b>one uppercase and one lowercase letter</b></li>
        <li>At least <b>one number</b></li>
        <li>At least <b>one special character</b></li>
    </div>
    <div>Click below to request a new Password Reset Link</div></div>;
    const container = document.createElement("div");
    document.body.appendChild(container);
    const root = createRoot(container);

    const handleCancel = () => {
      reject(SIGN_IN_STATUS.CLOSE_POPUP);
      root.unmount();
      document.body.removeChild(container);
    };

    root.render(
      <ReactivationResetPopup
        promptMessage={promptMessage}
        onCancel={handleCancel}
        emailId={emailId}
      />
    );
  });
};

export const complete2FAEnrollment = async (verifyId, OTP, deviceName) => {
  const auth = getAuth(app)
  const multiFactorUser = multiFactor(auth.currentUser)
  // Ask user for the verification code.
  let cred = PhoneAuthProvider.credential(verifyId, OTP);
  let multiFactorAssertion = PhoneMultiFactorGenerator.assertion(cred);
  // Complete enrollment.
  return await multiFactorUser.enroll(multiFactorAssertion, deviceName);
}


export const enrollSecondFactor = (phone) => { //CUP-666
  return new Promise((resolve, reject) => {
    const auth = getAuth(app);
    try {
      if (!window.recaptchaVerifier2FA) {
        window.recaptchaVerifier2FA = new RecaptchaVerifier(
          auth,
          "captcha-container-2fa",
          {
            "size": "invisible",
            "callback": function (response) {
            },
            "expired-callback": function () {
            }
          }
        );
      }

      multiFactor(auth.currentUser)
        .getSession()
        .then(session => {
          // Specify the phone number and pass the MFA session.
          var phoneInfoOptions = {
            phoneNumber: phone,
            session: session
          };
          let phoneAuthProvider = new PhoneAuthProvider(auth);
          // Send SMS verification code.

          phoneAuthProvider.verifyPhoneNumber(phoneInfoOptions, window.recaptchaVerifier2FA).then((verificationId) => {
            //console.log("verificationId", verificationId);
            resolve(verificationId)
          }).catch((error) => {
            reject(error)
          })

        }).catch((error) => {
          reject(error)
        })
    } catch (error) {
      reject(error)
    }
  })
}

export const enableRecaptcha = () => { //CUP-666
  try {
    const auth = getAuth(app)
    if (!window.recaptchaVerifier) {
      window.recaptchaVerifier = new RecaptchaVerifier(
        auth,
        "captcha-container",
        {
          "size": "invisible",
          "callback": function (response) {
          },
          "expired-callback": function () {
          }
        }
      );


      /*window.recaptchaVerifier.render().then(function (widgetId) {
        window.recaptchaWidgetId = widgetId;
      });*/
    }
  } catch (error) {
    console.log("error", error);
    //window.recaptchaVerifier?.clear();
    //alert(SIGN_IN_ERROR_MESSAGES.RECAPTCHA_ISSUE);
    showAlertPopup({alertHeader:"Alert"},{alertMessage:SIGN_IN_ERROR_MESSAGES.RECAPTCHA_ISSUE});
  }
}